import { Fragment, useContext } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Bars3Icon, BellIcon, XMarkIcon } from "@heroicons/react/24/outline";
import AuthContext from "../../../AuthContext";
import { Link, useNavigate } from "react-router-dom";
import APP_CONSTANTS from "../../../constants/app.constants";
import { HiMiniArrowDownOnSquare } from "react-icons/hi2";
import IcLgo from "../../../assets/imgs/logo-bg.png";

const imgUrl = 'https://freesvg.org/img/abstract-user-flat-1.png';




function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Header() {
  const authContext = useContext(AuthContext);
  const localStorageData = authContext.user ? authContext.user.user : {};
  const navigate = useNavigate();

  const menuItems = [
    { name: "Inventario", href: "/admin/inventory", current: false },
    { name: "Solicitudes", href: "/admin/manage-store", current: false },
    { name: "Envíos", href: "/admin/shipments", current: false },
  ];
  const menuActions = [
    { name: "Salir", href: "/", current: false , action: () => {  authContext.signout() }},
    { name: "Salir a menu", current: false , action: () => { navigate("/") }},
  ];
  
  if (localStorageData?.id_perfil === APP_CONSTANTS.PERFIL.ADMIN) {
    menuItems[0].current = false; // Set 'Inventario' to false for Admin
  }

  return (
    <>
      <div className="min-h-full">
        <Disclosure as="nav" className="bg-black">
          {({ open }) => (
            <>
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 items-center justify-between">

                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <div className="flex font1 text-white gap-1 items-center">
                        <div className="text-2xl pt-2 flex gap-1">
                          <div className="flex">Low</div>
                          <div className="flex text-cyan-600">Cost</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <img src={IcLgo}  width={78}  />


                  <div className="hidden md:block">
                    <div className="ml-4 flex items-center md:ml-6">
                      <button
                        type="button"
                        className="rounded-full bg-black p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                      >
                        <span className="sr-only">View notifications</span>
                        <BellIcon className="h-6 w-6" aria-hidden="true" />
                      </button>

                      {/* Profile dropdown */}
                      <Menu as="div" className="relative ml-3">
                        <div>
                          <Menu.Button className="flex max-w-xs items-center rounded-full bg-black text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                            <span className="sr-only">Open user menu</span>
                            <img
                              className="h-8 w-8 rounded-full invert"
                              src={imgUrl}
                              alt="profile"
                            />
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            {menuActions.map((item, i) => (
                              <Menu.Item key={item.name}>
                                {({ active }) => (
                                  <Link
                                    onClick={item.action}
                                    className={classNames(
                                      active ? "bg-gray-100" : "",
                                      "block px-4 py-2 text-sm text-gray-700"
                                    )}
                                  >
                                    {item.name}
                                  </Link>
                                )}
                              </Menu.Item>
                            ))}
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>

                  <div className="-mr-2 flex md:hidden">
                    {/* Mobile menu button */}
                    <Disclosure.Button className="
                    inline-flex items-center justify-center rounded-md 
                    bg-black p-2 text-gray-300 hover:bg-gray-700 
                    hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon
                          className="block h-6 w-6"
                          aria-hidden="true"
                          color="white"

                        />
                      ) : (
                        <Bars3Icon
                          className="block h-6 w-6"
                          aria-hidden="true"
                          color="white"
                        />
                      )}
                    </Disclosure.Button>
                  </div>

                </div>
              </div>

              <Disclosure.Panel className="md:hidden">
                <div className="space-y-1 px-2 pb-3 pt-2 sm:px-3">
                  {menuItems.map((item) => (
                    <Link to={item.href} key={item.name} className="no-underline">
                      <Disclosure.Button
                        key={item.name}
                        as="div"
                        className={classNames(
                          item.current
                            ? "bg-gray-900 text-white"
                            : "text-gray-300 hover:bg-gray-700 hover:text-white",
                          "block rounded-md px-3 py-2 text-base font-medium font1 text-xl no-underline"
                        )}
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </Disclosure.Button>
                    </Link>
                  ))}
                </div>
                <div className="border-t border-gray-700 ">
                  
                  <div className="pb-2 px-2">
                    {menuActions.map((item) => (
                      <Disclosure.Button
                      onClick={item.action}
                        key={item.name}
                        as="div"
                        className="font1  block rounded-md px-3 py-2 text-base text-xl text-rose-400 hover:bg-gray-700 hover:text-white"
                      >
                        <span >
                          {item.name}{" "}
                        </span>
                      </Disclosure.Button>
                    ))}
                  </div>
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </>
  );
}
